export const LEGAL_FIELD: any = {
    auditControlApproach: "AUDIT_CONTROL_APPROACH",
    businessType: "BUSINESS_TYPE",
    category: "CATEGORY",
    chiefAuditor: "CHIEF_AUDITOR",
    endDate: "END_DATE",
    lastTaxonomyCampaignCompletionDate: "LAST_TAXONOMY_CAMPAIGN_COMPLETION_DATE",
    lastTaxonomyCampaignStartingDate: "LAST_TAXONOMY_CAMPAIGN_STARTING_DATE",
    startDate: "START_DATE",
    valueChain: "VALUE_CHAIN",
    lastUpdated: "LAST_UPDATED",
    legalEntityTrackingId: "LEGAL_ENTITY_TRACKING_ID",
    businessUnit: "BUSINESS_UNIT",
    organizationalUnit: "ORGANIZATIONAL_UNIT",
    id: "ID",
    legalEntityCode: "LEGAL_ENTITY_CODE",
    legalEntityName: "LEGAL_ENTITY_NAME",
    legalEntitySize: "LEGAL_ENTITY_SIZE",
    macroBusinessUnit: "MACRO_BUSINESS_UNIT",
    status: "STATUS",
    null: null
}

































